// /**
//  * Gets the repositories of the user from Github
//  */
import { sagas as emailVerificationRoot } from '../EmailVerification/store';
import { spawn } from 'redux-saga/effects';

export default function* rootSaga() {
  yield spawn(emailVerificationRoot)
}
